import React from 'react'

import Editor from '@SonarCX/components/organisms/LexicalEditor'
import ButtonSecondary from '@SonarCX/components/atoms/ButtonSecondary'
import Tooltip from '@SonarCX/components/atoms/Tooltip'
import Button from '@SonarCX/components/atoms/Button2'

import useStyles from './styles'

type NoteEditorProps = {
  title: string
  setTitle: React.Dispatch<React.SetStateAction<string>>
  internalValue: string
  setInternalValue: React.Dispatch<React.SetStateAction<string>>
  onCancel: () => void
  onSave: () => void
  setChanged: React.Dispatch<React.SetStateAction<boolean>>
}

const NoteEditor: React.FC<NoteEditorProps> = ({
  title,
  setTitle,
  internalValue,
  setInternalValue,
  onCancel,
  onSave,
  setChanged
}) => {
  const saveDisabled = React.useMemo(() => title.trim().length === 0, [title])

  const classes = useStyles()

  return (
    <>
      <input
        placeholder='Note title (required)'
        autoFocus
        value={title}
        onChange={e => {
          setChanged(true)
          setTitle(e.target.value)
        }}
        className={classes.title}
      />

      <Editor
        disableImages
        showSpeechToText={false}
        value={internalValue}
        onChange={value => {
          setChanged(true)
          setInternalValue(value)
        }}
        placeholder='Enter note'
        className={classes.editor}
      />

      <div className={classes.buttons}>
        <ButtonSecondary onClick={onCancel} className={classes.button}>
          Cancel
        </ButtonSecondary>

        <Tooltip title={saveDisabled ? 'Title required' : null} arrow>
          <div>
            <Button
              disabled={saveDisabled}
              onClick={onSave}
              className={classes.button}
            >
              Save
            </Button>
          </div>
        </Tooltip>
      </div>
    </>
  )
}

export default NoteEditor
